import UpslidingText from "components/Upsliding-Text";
import React from "react";

const ContactSection = ({ work = null }) => {
  return (
    <div className={`${work ? `mt-32 md:mt-72` : `mt-24 md:mt-48`}`}>
      <p className='text-dark dark:text-light text-xl md:text-5xl'>
        Want to Start a Project?
      </p>
      <UpslidingText
        maxHeight='max-h-[60px] md:max-h-[270px]'
        text="Let's Talk"
        textSize={"text-[56px] md:text-[250px] leading-none"}
        noUnderline
        color={"text-dark dark:text-light"}
        onClick={(e) => {
          window.location.assign(
            "mailto:mominnaveed1997@gmail.com?subject=Lets%20work%20together!&amp;body=Hello%2C%20I%20think%20we%20need%20you%20to%20work%20on%2Fcollaborate%20this%20particular%20product...%20Reach%20out%20as%20soon%20as%20you%20can.",
          );
        }}
      />
    </div>
  );
};

export default ContactSection;
